import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config";
import { errorDispatch } from "../../../functions/errorDispatch";
import i18next from "../../../functions/i18next";

export default {
  data() {
    return {
      id: this.$options.name,
      optionsData: {},
      focus: true,
    };
  },
  created() {
    EventBus.$on(`${this.id}-show`, (data) => {
      //show this overlay
      EventBus.$emit("openOverlayPage", data);

      if (data.optionsData) {
        this.optionsData = data.optionsData;
      } else {
        this.optionsData = {};
      }

      this.focusInput();
    });

    EventBus.$on(`${this.id}-rename`, (data) => {
      if (data.id) {
        this.renameItem();
      }
    });
  },

  methods: {
    renameItem() {
      const formData = new FormData(this.$refs.renameCollectionForm);

      formData.append("collectionid", this.optionsData.collection_id);

      this.$axios
        .post(`${baseUrl}/collectionedit`, formData)
        .then((r) => {
          //update name
          EventBus.$emit("mobile-collection-detail-update", {});

          //close overlay
          EventBus.$emit("closeOverlayPage", { id: this.$options.name });

          //reset the focus
          this.focus = false;
        })
        .catch((e) => {
          errorDispatch(i18next.t("error.rename_collection"));
        });
    },

    enterFunc(e) {
      e.preventDefault();

      this.renameItem();
    },
    focusInput() {
      this.focus = !this.focus;
    },
  },
};
